import {
  DESIGN_TOKENS,
  THEME_COLORS,
  THEME_SHADOWS,
  getDesignTokens,
} from '@/lib/design/designSystem';
import { DarkTheme, DefaultTheme, type Theme } from '@react-navigation/native';

const DAY_THEME = {
  background: THEME_COLORS.day.canvas,
  foreground: THEME_COLORS.day.text,
  card: THEME_COLORS.day.surface,
  cardForeground: THEME_COLORS.day.text,
  popover: THEME_COLORS.day.surfaceOverlay,
  popoverForeground: THEME_COLORS.day.text,
  primary: THEME_COLORS.day.accent,
  primaryForeground: THEME_COLORS.day.textInverse,
  secondary: THEME_COLORS.day.surfaceRaised,
  secondaryForeground: THEME_COLORS.day.text,
  muted: THEME_COLORS.day.canvasInset,
  mutedForeground: THEME_COLORS.day.textMuted,
  accent: THEME_COLORS.day.surfaceAlt,
  accentForeground: THEME_COLORS.day.text,
  destructive: 'hsl(0 84.2% 60.2%)',
  border: THEME_COLORS.day.border,
  input: THEME_COLORS.day.border,
  ring: THEME_COLORS.day.accent,
  radius: '0.625rem',
  chart1: 'hsl(43 82% 58%)',
  chart2: 'hsl(18 78% 57%)',
  chart3: 'hsl(205 58% 50%)',
  chart4: 'hsl(92 40% 48%)',
  chart5: 'hsl(340 70% 63%)',
} as const;

const NIGHT_THEME = {
  background: THEME_COLORS.night.canvas,
  foreground: THEME_COLORS.night.text,
  card: THEME_COLORS.night.surface,
  cardForeground: THEME_COLORS.night.text,
  popover: THEME_COLORS.night.surfaceOverlay,
  popoverForeground: THEME_COLORS.night.text,
  primary: THEME_COLORS.night.accent,
  primaryForeground: THEME_COLORS.night.textInverse,
  secondary: THEME_COLORS.night.surfaceRaised,
  secondaryForeground: THEME_COLORS.night.text,
  muted: THEME_COLORS.night.canvasInset,
  mutedForeground: THEME_COLORS.night.textMuted,
  accent: THEME_COLORS.night.canvasInset,
  accentForeground: THEME_COLORS.night.text,
  destructive: 'hsl(0 70.9% 59.4%)',
  border: THEME_COLORS.night.border,
  input: THEME_COLORS.night.border,
  ring: THEME_COLORS.night.accent,
  radius: '0.625rem',
  chart1: 'hsl(220 70% 50%)',
  chart2: 'hsl(160 60% 45%)',
  chart3: 'hsl(30 80% 55%)',
  chart4: 'hsl(280 65% 60%)',
  chart5: 'hsl(340 75% 55%)',
} as const;

export const THEME = {
  light: DAY_THEME,
  dark: NIGHT_THEME,
} as const;

export { DESIGN_TOKENS, THEME_COLORS, THEME_SHADOWS, getDesignTokens };

export const NAV_THEME: Record<'light' | 'dark', Theme> = {
  light: {
    ...DefaultTheme,
    colors: {
      background: THEME.light.background,
      border: THEME.light.border,
      card: THEME.light.card,
      notification: THEME.light.destructive,
      primary: THEME.light.primary,
      text: THEME.light.foreground,
    },
  },
  dark: {
    ...DarkTheme,
    colors: {
      background: THEME.dark.background,
      border: THEME.dark.border,
      card: THEME.dark.card,
      notification: THEME.dark.destructive,
      primary: THEME.dark.primary,
      text: THEME.dark.foreground,
    },
  },
};
